import boxShadows from "../../base/boxShadows";
import typography from "../../base/typography";
import colors from "../../base/colors";
import borders from "../../base/borders";
import pxToRem from "../../functions/pxToRem";

const { lg } = boxShadows;
const { size } = typography;
const { text, white, transparent, dark, gradients, secondary, inputColors } = colors;
const { borderRadius, borderWidth } = borders;

export default {
  styleOverrides: {
    root: {
      backgroundColor: `${inputColors.borderColor.main}`,
      border: 'none !important',
      // border: `${borderWidth[2]} solid ${inputColors.borderColor.main}`,
      borderRadius: `${borderRadius.md}`,
      "&:focus-within": {
        backgroundColor: `${white.main}`,
        border: `${borderWidth[2]} solid ${inputColors.borderColor.focus}`,
      },
      "& > .MuiFormControl-root .MuiInputBase-root": {
        backgroundColor: `${transparent.main} !important`,
        padding: "0 6px",
      },
    },
    popper: {
      boxShadow: lg,
      padding: pxToRem(8),
      fontSize: size.sm,
      color: text.main,
      textAlign: "left",
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.sm,
    },

    paper: {
      boxShadow: "none",
      backgroundColor: transparent.main,
    },

    option: {
      padding: `${pxToRem(4.8)} ${pxToRem(16)}`,
      borderRadius: "2px",
      fontSize: size.sm,
      color: text.main,
      transition: "background-color 300ms ease, color 300ms ease",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus": {
        backgroundColor: secondary.main,
        color: dark.main,
      },

      '&[aria-selected="true"]': {
        backgroundColor: `${transparent.main} !important`,
        color: `${text.main} !important`,
      },
    },

    noOptions: {
      fontSize: size.sm,
      color: text.main,
    },

    groupLabel: {
      color: dark.main,
    },

    loading: {
      fontSize: size.sm,
      color: text.main,
    },

    tag: {
      display: "flex",
      alignItems: "center",
      height: "auto",
      padding: pxToRem(4),
      backgroundColor: gradients.dark.state,
      color: white.main,

      "& .MuiChip-label": {
        lineHeight: 1.2,
        padding: `0 ${pxToRem(10)} 0 ${pxToRem(4)}`,
      },

      "& .MuiSvgIcon-root, & .MuiSvgIcon-root:hover, & .MuiSvgIcon-root:focus": {
        color: white.main,
        marginRight: 0,
      },
    },
  },
};
